import { Card, Table } from "antd"
import { getProjectUrl } from "../datacenterModel"
import { projectTypeName } from "../../../common/constants"
import { VisitNotesReportData } from "./visitNotesReportApi"
import ExportCsvButton from "../ExportCsvButton"
import useDashboardReporting from "../../../hooks/useDashboardReporting"
import { CsvDateRange } from "../reportCsvExport"
import { visitNotesExportColumns } from "./visitNotesReportExport"


type Props = {
  visitNotes: VisitNotesReportData[]
  dateRange: CsvDateRange
}

const VisitNotesReportList = ({ visitNotes, dateRange }: Props) => {
  const dashboardReporting = useDashboardReporting()
 
  return <Card extra={dashboardReporting && <ExportCsvButton reportName='Visit Notes' dateRange={dateRange} columns={visitNotesExportColumns} rows={visitNotes} />}>
    <Table
      dataSource={visitNotes}
      rowKey={(record) => record.timecardId}
      pagination={{ showSizeChanger: true }}
      columns={[
        {
          title: 'Date',
          dataIndex: 'dateUtc',
          render: (date) => new Date(date).toLocaleDateString()
        },
        {
          title: 'Project Name',
          dataIndex: 'name',
        },
        {
          title: 'Job Type',
          dataIndex: 'jobType',
          render: (_, record) => projectTypeName(record.jobType)
        },
        {
          title: 'Customer',
          dataIndex: 'customerDisplayName',
        },
        {
          title: 'User',
          dataIndex: 'userDisplayName',
        },
        {
          title: 'Client Notes',
          dataIndex: 'clientNotes',
        },
        {
          title: 'Internal Notes',
          dataIndex: 'internalNotes',
        }
      ]}
      onRow={(record) => {
        const jobUrl = getProjectUrl(record.jobId, record.jobType, record.sold, record.name)

        return {
          onClick: () => window.open(`#!/${jobUrl}`, '_blank'),
          style: { cursor: 'pointer' }
        }
      }}
    />
  </Card>
}

export default VisitNotesReportList